
<div>
  
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row" >
      <div class="col-md-12">
        <div class="row" >
          <!-- Pravac dokumenta -->
          <div class="col-md-2 col-12">
            <div class="form-group row">
              <div class="col-md-12" >
                <yt-dropdown-picklist 
                [ModelName]="'PojedinacnaEvidencijaPdv'" 
                [GetName]="'GetPravacDokumenta'"                         
                [ModelProperty]="'Naziv'"                  
                formControlName="PravacDokumentaId"                                  
                [Label]="'POJEDINACNAEVIDENCIJAPDV.PRAVACDOKUMENTA.SINGULAR'"
                [RouteName]="'pravacdokumenta'"                
                (OnItemSelected)="onPravacDokumentaSelect($event)"
                [AllowAddNew]="false"
                [AutoSelect]="true">
              </yt-dropdown-picklist>  
              </div>
            </div>
          </div>
          <!-- Tip dokumenta -->
          <div class="col-md-2">
            <div class="form-group row">
              <div class="col-md-12" >
                <yt-dropdown-picklist 
                [ModelName]="'PojedinacnaEvidencijaPdv'"
                [GetName]="'GetTipDokumentaSef'" 
                [GetParameters]='parameterListTipDokumenta'                         
                [ModelProperty]="'Naziv'" 
                [OrderBy]="'Naziv'"                
                formControlName="TipDokumentaSefId"                                  
                [Label]="'POJEDINACNAEVIDENCIJAPDV.TIPDOKUMENTA.SINGULAR'"    
                [RouteName]="'tipdokumentasef'"            
                (OnItemSelected)="onTipDokumentaSelect($event)"
                [ngClass]="{ 'is-invalid': submitted && fc.TipDokumentaSefId.invalid }"
                [AllowAddNew]="false"
                [AllowEdit]="false"
                #autofocus>
              </yt-dropdown-picklist > 
              <div class="form-error" *ngIf="submitted && fc.TipDokumentaSefId.invalid">
                <span *ngFor="let validation of errorMessages.TipDokumentaSefId">
                    <span class="error-message" *ngIf="fc.TipDokumentaSefId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div> 
              </div>
            </div>
          </div>
            <!-- Fak dokument   -->
            <div class="col-lg-6">
              <div class="form-group row">
                <div class="col-md-12">
                  <yt-dropdown-picklist 
                  #dropDownPickListComponent
                    [ModelName]="'fakdokument'" 
                    [GetName]="'GetForPojedinacnaEvidencijaPdv'"
                    [GetParameters]='parameterListRacun'
                    [ModelProperty]="'BrojDokumenta,Komitent'"
                    [TableColumns]="TableColumnsFakDokum"                                              
                    formControlName="FakDokumMasterDokumID"                                  
                    [Label]="'POJEDINACNAEVIDENCIJAPDV.FAKDOKUM.SINGULAR'"                
                    (OnItemSelected)="onFakDokumentSelect($event)"
                    [AllowAddNew]="false"
                    [AllowEdit]="false" >
                  </yt-dropdown-picklist >  
                </div>
              </div>             
            </div>                        
           <!-- <div class="col-lg-6 col-12" *ngIf="showAvansi">
              <div class="form-group row">
                <div class="col-md-12" >
                  <yt-dropdown-picklist 
                  #dropDownPickListComponent
                    [ModelName]="'fakdokument'" 
                    [GetName]="'GetForPojedinacnaEvidencijaPdv'"
                    [GetParameters]='parameterListAvans'
                    [ModelProperty]="'BrojDokumenta,Komitent'"
                    [TableColumns]="TableColumnsFakDokum"                                              
                    formControlName="FakDokumMasterDokumID"                                  
                    [Label]="'POJEDINACNAEVIDENCIJAPDV.FAKDOKUM.SINGULAR'"                
                    (OnItemSelected)="onFakDokumentSelect($event)"
                    [AllowAddNew]="false"
                    [AllowEdit]="false">
                  </yt-dropdown-picklist >  
                </div>
              </div>
            </div> 
             <div class="col-lg-6 col-12" *ngIf="showKo">
              <div class="form-group row">
                <div class="col-md-12" >
                  <yt-dropdown-picklist 
                  #dropDownPickListComponent
                    [ModelName]="'fakdokument'" 
                    [GetName]="'GetForPojedinacnaEvidencijaPdv'"
                    [GetParameters]='parameterListKo'
                    [ModelProperty]="'BrojDokumenta,Komitent'"
                    [TableColumns]="TableColumnsFakDokum"                                              
                    formControlName="FakDokumMasterDokumID"                                  
                    [Label]="'POJEDINACNAEVIDENCIJAPDV.FAKDOKUM.SINGULAR'"                
                    (OnItemSelected)="onFakDokumentSelect($event)"
                    [AllowAddNew]="false"
                    [AllowEdit]="false">
                  </yt-dropdown-picklist >  
                </div>
              </div>
            </div> 
            <div class="col-lg-6 col-12" *ngIf="showKz">
              <div class="form-group row">
                <div class="col-md-12" >
                  <yt-dropdown-picklist 
                  #dropDownPickListComponent
                    [ModelName]="'fakdokument'" 
                    [GetName]="'GetForPojedinacnaEvidencijaPdv'"
                    [GetParameters]='parameterListKz'
                    [ModelProperty]="'BrojDokumenta,Komitent'"
                    [TableColumns]="TableColumnsFakDokum"                                              
                    formControlName="FakDokumMasterDokumID"                                  
                    [Label]="'POJEDINACNAEVIDENCIJAPDV.FAKDOKUM.SINGULAR'"                
                    (OnItemSelected)="onFakDokumentSelect($event)"
                    [AllowAddNew]="false"
                    [AllowEdit]="false">
                  </yt-dropdown-picklist >  
                </div>
              </div>
            </div> -->
            <!-- Broj pojedinacne evidencije pdv  -->
            <div class="col-lg-2">
              <div class="form-group row">
                <div class="col-md-12">
                  <yt-input [Type]="'text'" 
                            [Label]="'POJEDINACNAEVIDENCIJAPDV.BROJPOJEDINACNEEVIDENCIJE.SINGULAR'" 
                            formControlName="BrojObracuna">
                  </yt-input>
                </div>
              </div>
            </div>             
        </div>
      </div>
    </div>
    <div class="row" *ngIf="false">
      <div class="col-md-12">
        <div class="row">
            <!-- Broj dokumenta   -->
          <div class="col-md-6">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input [Type]="'text'" 
                          [Label]="'POJEDINACNAEVIDENCIJAPDV.BRDOK.SINGULAR'" 
                          formControlName="BrojDokumenta">
                </yt-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">

          <!-- Datum evidentiranja -->
          <div class="col-md-3" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  formControlName="DatumObracuna"
                  name="txtDatEvidentiranja"
                  [Label]="'POJEDINACNAEVIDENCIJAPDV.DATEVIDENTIRANJA.SINGULAR'">
                </yt-fw-date-picker-popup>
              </div>
          </div>
        </div> 
          <!-- Komitent -->
          <div class="col-md-6">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-dropdown-picklist 
                [ModelName]="'komitent'" 
                [GetName]="'get'"                         
                [ModelProperty]="'SNaziv'"                  
                formControlName="KomitentID"                                  
                [Label]="'POJEDINACNAEVIDENCIJAPDV.KOMITENT.SINGULAR'"
                [TableColumns]="TableColumnsKomitent"
                [AllowAddNew]="false"
                (OnItemSelected)="onKomitentSelect($event)">
              </yt-dropdown-picklist>  
              </div>
            </div>
          </div> 
           <!-- Identifikator posiljaoca  -->
           <div class="col-md-3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.IDENTIFIKATORPRIMAOCA.SINGULAR'" 
                formControlName="IdentifikatorPosiljaoca"
                [ngClass]="{ 'is-invalid': submitted && fc.IdentifikatorPosiljaoca.invalid }"
                [MaxLength]="13">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.IdentifikatorPosiljaoca.invalid">
                  <span *ngFor="let validation of errorMessages.IdentifikatorPosiljaoca">
                      <span class="error-message" *ngIf="fc.IdentifikatorPosiljaoca.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>                                    
           <!-- Datum dokumenta   -->
          <!-- <div class="col-md-6">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  formControlName="DatumDokumenta"
                  name="txtDatDok"
                  [Label]="'POJEDINACNAEVIDENCIJAPDV.DATDOK.SINGULAR'">
                </yt-fw-date-picker-popup>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-12">
        <div class="row">



        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Godina -->
          <div class="col-lg-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.GODINA.SINGULAR'" 
                formControlName="Godina"
                [ngClass]="{ 'is-invalid': submitted && fc.Godina.invalid }"
                [MaxLength]="4">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Godina.invalid">
                  <span *ngFor="let validation of errorMessages.Godina">
                      <span class="error-message" *ngIf="fc.Godina.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>          
           <!-- Poreski period  -->
           <div class="col-lg-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-dropdown-picklist 
                [ModelName]="'PojedinacnaEvidencijaPdv'"                          
                [GetName]="'GetPoreskiPeriod'"                         
                [ModelProperty]="'Naziv'"                 
                formControlName="PoreskiPeriodId"                                  
                [Label]="'POJEDINACNAEVIDENCIJAPDV.PORESKIPERIOD.SINGULAR'"                
                (OnItemSelected)="onPoreskiPeriodSelect($event)"
                [RouteName]="'poreskiperiod'"
                [ngClass]="{ 'is-invalid': submitted && fc.PoreskiPeriodId.invalid }"
                #focusElement
                #autofocus
                [AllowAddNew]="false"
                [AllowEdit]="false">
              </yt-dropdown-picklist >
              <div class="form-error" *ngIf="submitted && fc.PoreskiPeriodId.invalid">
                <span *ngFor="let validation of errorMessages.PoreskiPeriodId">
                    <span class="error-message" *ngIf="fc.PoreskiPeriodId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div> 
              </div>
            </div>
          </div>           
          <!-- Period -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12" >
              <yt-dropdown-picklist 
              [ModelName]="'PojedinacnaEvidencijaPdv'"
              [GetName]="'getPeriod'" 
              [GetParameters]='parameterListPeriod'                         
              [ModelProperty]="'Naziv'"
              [Type]="'list'"                  
              formControlName="PeriodId"                                  
              [Label]="'POJEDINACNAEVIDENCIJAPDV.PERIOD.SINGULAR'"
              [RouteName]="'period'"
              [ngClass]="{ 'is-invalid': submitted && fc.PeriodId.invalid }"
              [AllowAddNew]="false"
              [AllowEdit]="false"
              (OnItemSelected)="onPeriodSelect($event)">
            </yt-dropdown-picklist >
            <div class="form-error" *ngIf="submitted && fc.PeriodId.invalid">
              <span *ngFor="let validation of errorMessages.PeriodId">
                  <span class="error-message" *ngIf="fc.PeriodId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Osnov prometa po stopi 20%  -->
          <div class="col-lg-6 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OPISPROMETASTOPA20.SINGULAR'" 
                formControlName="OpisPrometaStopa20">
              </yt-input>
              </div>
            </div>
          </div>
          <!-- Osnov prometa po stopi 10%  -->
          <div class="col-lg-6 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OPISPROMETASTOPA10.SINGULAR'" 
                formControlName="OpisPrometaStopa10">
              </yt-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
           <!-- Osnovica pdv stopa 20  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtOsnovicaPdvStopa20"
                formControlName="OsnovicaPdvStopa20"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OSNOVICAPDVSTOPA20.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
           <!-- Osnovica pdv stopa 10  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtOsnovicaPdvStopa10"
                formControlName="OsnovicaPdvStopa10"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OSNOVICAPDVSTOPA10.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
           <!-- Obracunati pdv po stopi 20  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtObracunatiPdvStopa20"
                formControlName="ObracunatiPdvStopa20"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OBRACUNATIPDVSTOPA20.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
           <!-- Obracunati pdv po stopi 10  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtObracunatiPdvStopa10"
                formControlName="ObracunatiPdvStopa10"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OBRACUNATIPDVSTOPA10.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
           <!-- Ukupno obracunati pdv  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtUkupanIznosNaknade"
                formControlName="UkupanIznosNaknade"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.UKUPANIZNOSNAKNADE.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
           <!-- Ukupan iznos naknade -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                name="txtObracunatiPdv"
                formControlName="ObracunatiPdv"
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OBRACUNATIPDV.SINGULAR'">
              </yt-number-input-v3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
           <!-- Osnov za avansno placanje -->
          <div class="col-md-3" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.OSNOVZAAVANSNOPLACANJE.SINGULAR'" 
                formControlName="OsnovZaAvansnoPlacanje">
              </yt-input>
              </div>
            </div>
          </div>
          <!-- Datum placanja -->
          <div class="col-md-3" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  formControlName="DatumPlacanja"
                  name="txtDatPlacanja"
                  [Label]="'POJEDINACNAEVIDENCIJAPDV.DATPLACANJA.SINGULAR'">
                </yt-fw-date-picker-popup>
              </div>
            </div>
          </div>           
           <!-- Povezane avansne fakture  -->
          <div class="col-md-6" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.POVEZANEAVANSNEFAKTURE.SINGULAR'" 
                formControlName="BrojPovezanogDokumenta">
              </yt-input>
              </div>
            </div>
          </div>        
          <!-- <div class="col-md-3" >
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.POVEZANIDOKUMENTI.SINGULAR'" 
                formControlName="BrojPovezanogDokumenta2">
              </yt-input>
              </div>
            </div>
          </div>          -->
        </div>
      </div>
    </div>
    <div class="row" *ngIf="tipDokumentaGenericName && tipDokumentaGenericName != 'PrepaymentInvoice'">
      <div class="col-md-12"> 
        <div class="border rounded" >
          <div class="row">
            <div class="col-md-12">
              <div clas="text" style="margin: 10px;">
                <span style="color: #25749b; font-style: italic;">
                  Za SEF 3.9 (Ako pravite veze sa dokumentima obratite pažnju u koje polje treba da unosite brojeve dokumenata! U polje Broj povezanog dokumenta SEF se unosi ukoliko su veze otišle na novu pojedinačnu evidenciju.)
                </span>
              </div>
            </div>
          </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">       
                <div class="col-md-12">                     
                    <yt-dropdown-picklist 
                    [ModelName]="'commonString'"                          
                    [ModelProperty]="'Name'"                  
                    formControlName="RelatedInvoiceOption"                                                 
                    [Position]="'left'"
                    [AllowAddNew]="false" 
                    [Source]="povezaniDokumenti"
                    [Label]="'POJEDINACNAEVIDENCIJAPDV.POVEZANIDOKUMENTI.SINGULAR'"
                    [Required]="false"
                    (OnItemSelected)="OnPovezaniDokumentiSelect($event)">
                  </yt-dropdown-picklist >      
                  <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                    <span class="error-message"
                      *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkPovezaniDokumenti && !this.baseFormGroup.errors.checkPovezaniDokumenti.valid"><span
                        translate="{{this.baseFormGroup.errors.checkPovezaniDokumenti.message}}"></span></span>
                  </div>                 
                </div>            
            </div>
          </div>
          <div class="col-md-4" *ngIf="vrednostPovezanogDokumenta==2">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  formControlName="RelatedInvoiceIssueDateFrom"
                  name="txtDatumPrometaOD"
                  [Label]="'POJEDINACNAEVIDENCIJAPDV.DATUMPROMETAOD.SINGULAR'">
                </yt-fw-date-picker-popup>
              </div>
            </div>
          </div>  
          <div class="col-md-4" *ngIf="vrednostPovezanogDokumenta==2">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  formControlName="RelatedInvoiceIssueDateTo"
                  name="txtDatumPrometaOD"
                  [Label]="'POJEDINACNAEVIDENCIJAPDV.DATUMPROMETADO.SINGULAR'">
                </yt-fw-date-picker-popup>
              </div>
            </div>
          </div>  
          <div class="col-md-2" *ngIf="vrednostPovezanogDokumenta==1 && this.Item.ID == -1">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.VEZASADOKUMENTIMA.SINGULAR'" 
                formControlName="RelatedDocuments"
                >
              </yt-input>
              </div>
            </div>
          </div>  
          <div [ngClass]="{'col-md-3' : vrednostPovezanogDokumenta==1, 'col-md-4' : vrednostPovezanogDokumenta==3}" *ngIf="vrednostPovezanogDokumenta==1 || vrednostPovezanogDokumenta==3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.VEZASASEFDOKUMENTIMA.SINGULAR'" 
                formControlName="RelatedVatRecords"
                >
              </yt-input>
              </div>
            </div>
          </div>  
          <div [ngClass]="{'col-md-3' : vrednostPovezanogDokumenta==1, 'col-md-4' : vrednostPovezanogDokumenta==3}" *ngIf="vrednostPovezanogDokumenta==1 || vrednostPovezanogDokumenta==3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                [Type]="'text'" 
                [Label]="'POJEDINACNAEVIDENCIJAPDV.VEZASADOKUMENTIMAVANSEF.SINGULAR'" 
                formControlName="RelatedVatRecordOutOfSystem">
              </yt-input>
              </div>
            </div>
          </div> 
        </div>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
          <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"  [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
          </div>
      </div>
    </div>
  </form>
</div>